package com.anjuros.website.templates.template1.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.templates.template1.components.Template1SectionTitle
import com.anjuros.website.templates.template1.components.Template1TestimonialCard
import com.anjuros.website.templates.template1.modules.Template1Review
import com.anjuros.website.templates.template1.modules.Template1Section
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.modules.getColor
import com.anjuros.website.templates.template1.styles.Template1AboutColumnWidthStyle
import com.anjuros.website.templates.template1.styles.Template1ReviewStyle
import com.anjuros.website.templates.template1.styles.Template1SectionPaddingStyle
import com.anjuros.website.templates.template1.util.ResKey
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb

@Composable
fun Template1ReviewSection(){
    Box(modifier = Template1SectionPaddingStyle.toModifier()
        .id(Template1Section.Testimonial.id)
        .fillMaxWidth()
        .backgroundColor(
            rgb(252, 248, 244)
        ),
        contentAlignment = Alignment.Center) {

        Template1TestimonialContent()
    }
}

@Composable
private fun Template1TestimonialContent(){

    var selectedPage by remember { mutableStateOf(0) }
    Column(
        modifier = Template1AboutColumnWidthStyle.toModifier()
        ,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Template1SectionTitle(
            badge = ResKey.TEMPLATE1_REVIEWS_BADGE,
            title = ResKey.TEMPLATE1_REVIEWS_TITLE,
            text = ResKey.TEMPLATE1_REVIEWS_TEXT
        )
        TestimonialCards(selectedPage)
        TestimonialNavigation(selectedPage){
            selectedPage=it
        }

    }
}

@Composable
fun TestimonialCards(selectedPage: Int){

    val testimonial1 = listOf(Template1Review.Review1, Template1Review.Review3, Template1Review.Review5)
    val testimonial2 = listOf(Template1Review.Review2, Template1Review.Review4, Template1Review.Review6)

    SimpleGrid(
        modifier = Template1AboutColumnWidthStyle.toModifier().margin(top= 100.px, bottom = 40.px),
        numColumns = numColumns(base=1, md=2)) {

        Box {
            testimonial1.forEach {testimonial->
                Template1TestimonialCard(
                    modifier = getTestimonialModifier(Template1ReviewStyle.toModifier(),selectedPage,  testimonial),
                    testimonial=testimonial)
            }
        }
        Box {
            testimonial2.forEach {testimonial->
                Template1TestimonialCard(
                    modifier = getTestimonialModifier(Template1ReviewStyle.toModifier(),selectedPage, testimonial),
                    testimonial=testimonial)
            }
        }
    }
}

private fun getTestimonialModifier(modifier:Modifier,selectedPage: Int,
                                   testimonial: Template1Review):Modifier{


    return modifier
        .visibility(setVisibility(selectedPage,testimonial))
        .opacity(setOpacity(selectedPage, testimonial))
        .transition(
            Transition.Companion.of("visibility",300.ms),
            Transition.Companion.of("opacity",300.ms)
        )
}

@Composable
fun TestimonialNavigation(
    selectedPage:Int,
    onNavigate:(Int)->Unit
){
    Row(modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.Center){
        repeat(3){index->
            Box(
                modifier = Modifier.margin(right = 10.px)
                    .cursor(Cursor.Pointer)
                    .size(12.px)
                    .borderRadius(50.px)
                    .onClick { onNavigate(index) }
                    .backgroundColor(
                        if(selectedPage==index){
                            Template1Theme.Primary.getColor()
                        } else
                            Template1Theme.LightGray.rgb
                    )

            ) {}
        }
    }
}

private fun setVisibility(
    selectedPage: Int,
    testimonial: Template1Review
): Visibility {
    return when (testimonial) {
        Template1Review.Review1 -> {
            if (selectedPage == 0) Visibility.Visible else Visibility.Hidden
        }

        Template1Review.Review2 -> {
            if (selectedPage == 0) Visibility.Visible else Visibility.Hidden
        }

        Template1Review.Review3 -> {
            if (selectedPage == 1) Visibility.Visible else Visibility.Hidden
        }

        Template1Review.Review4 -> {
            if (selectedPage == 1) Visibility.Visible else Visibility.Hidden
        }

        Template1Review.Review5 -> {
            if (selectedPage == 2) Visibility.Visible else Visibility.Hidden
        }

        Template1Review.Review6 -> {
            if (selectedPage == 2) Visibility.Visible else Visibility.Hidden
        }
    }
}

private fun setOpacity(
    selectedPage: Int,
    testimonial: Template1Review
): CSSSizeValue<CSSUnit.percent> {
    return when (testimonial) {
        Template1Review.Review1 -> {
            if (selectedPage == 0) 100.percent else 0.percent
        }

        Template1Review.Review2 -> {
            if (selectedPage == 0) 100.percent else 0.percent
        }

        Template1Review.Review3 -> {
            if (selectedPage == 1) 100.percent else 0.percent
        }

        Template1Review.Review4 -> {
            if (selectedPage == 1) 100.percent else 0.percent
        }

        Template1Review.Review5 -> {
            if (selectedPage == 2) 100.percent else 0.percent
        }

        Template1Review.Review6 -> {
            if (selectedPage == 2) 100.percent else 0.percent
        }
    }
}